import { render, staticRenderFns } from "./fccListaGabaritos.vue?vue&type=template&id=d3865266"
import script from "./fccListaGabaritos.vue?vue&type=script&lang=js"
export * from "./fccListaGabaritos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports